import { render } from "./ConfigYear.vue?vue&type=template&id=528e55d4"
import script from "./ConfigYear.vue?vue&type=script&lang=js"
export * from "./ConfigYear.vue?vue&type=script&lang=js"

import "./ConfigYear.vue?vue&type=style&index=0&id=528e55d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__